import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Row, Col } from 'reactstrap';

const FeetLayout = ({ banner, aside, footer, isStickyAside = true, children }) =>
<>
  {banner}
  <Row noGutters>
    <Col lg={12} className={classNames('pr-lg-2', { 'mb-3': !isStickyAside })}>
      {children}
    </Col>
  </Row>
  {footer}
</>

FeetLayout.propTypes = {
  aside: PropTypes.element,
  banner: PropTypes.element,
  footer: PropTypes.element,
  isStickyAside: PropTypes.bool,
  children: PropTypes.node
};


export default FeetLayout;